var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"text-capitalize text-decoration-underline",attrs:{"text":"","color":"grey"},on:{"click":_vm.resetFilters}},[_vm._v("\n    "+_vm._s(_vm.$t('sidebar.btnResetFilters'))+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a810b1e2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sidebar/cutaway/components/ButtonText.vue
// module id = null
// module chunks = 